import { schema } from 'normalizr';

const incidentReport = new schema.Entity('incidentReports');

export default incidentReport;

